<script lang="ts">
  import { patchWithJwt, serverlessRoutes, storage, translate } from "lib";
  import { dialogData, showAlert, user } from "stores";
  import { ButtonComponent, CheckboxComponent, InputField } from "ui";

  let phoneNumber: string;
  let isChecked = false;

  const close = async () => {
    if (isChecked) {
      await storage.set("showPhonenumberDialog", false);
    }
    $dialogData.type = "";
  };

  const submit = async () => {
    await storage.set("showPhonenumberDialog", false);

    const url = serverlessRoutes.USER;
    try {
      await patchWithJwt(url, { user: { id: $user.id, phoneNumber } });
      $showAlert.message = "Uspešno ažuriran broj telefona.";
      $dialogData.type = "";
    } catch (err: any) {
      $showAlert.message = err.data.message;
      $dialogData.type = "";
    }
  };
</script>

<div class="p-4 flex flex-col gap-4">
  <div class="text-justify">
    Nije loše da uneseš broj telefona za slučaj da zabaguje app.
    Evo ti moj broj da imaš:
    <span class="font-bold">061 2844389</span>
  </div>

  <InputField
    label="Broj telefona"
    placeholder="+381612345678"
    bind:value={phoneNumber}
  />

  <CheckboxComponent bind:value={isChecked} label="Ne prikazuj više" />

  <div class="mt-4 flex justify-between">
    <ButtonComponent isOutline on:click={close}>
      {translate("CLOSE")}
    </ButtonComponent>
    <ButtonComponent on:click={submit}>{translate("SUBMIT")}</ButtonComponent>
  </div>
</div>
